import React, { Component, createRef } from 'react';
import gsap from "gsap";
import { URLImgFront } from '../../config/URLDB';
import Detalle_PlanExequial from './Prevision_Exequial/Detalle_PlanExequial';
import Detalle_Seguro from './Proteccion/Detalle_Seguro';
import PreguntasFrecuentesSeguros from './Faq/PreguntasFrecuntesSeguros';
import '../../pages/style.css';

import { DetalleSeguros_ } from '../../services/WebAPI_Utrahuilca';
import Swal from 'sweetalert2';

class Seccion2 extends Component {
    constructor(props) {
        super(props);
        this.state = {
            estado: true,
            cambiovista: false,
            indexactual: 0,
            idplan: 0,
            vista: 0,
            ruta: "",
            mostrar: false,
            planes: [],
            seguros: []
        };

        this.anchoCard = 400;
        this.cardsVisibles = 4;
        this.animacion = false;

        this.btnPrevRef = createRef();
        this.btnProtRef = createRef();
        this.sliderRef = createRef();
        this.tituloRef = createRef();
        this.sliderContRef = createRef();
        this.detalleRef = createRef(); 
    }

    componentDidMount() {
        this.DatosSeguros();
        const tl = gsap.timeline({ defaults: { ease: "power3.out" } });
        tl.fromTo(
            [this.btnPrevRef.current, this.btnProtRef.current],
            { opacity: 0, y: -30 },
            { opacity: 1, y: 0, duration: 0.6, stagger: 0.15 }
        )
            .fromTo(
                this.tituloRef.current,
                { opacity: 0, y: 20 },
                { opacity: 1, y: 0, duration: 0.5 },
                "-=0.3"
            )
            .fromTo(
                this.sliderContRef.current,
                { opacity: 0, y: 40 },
                { opacity: 1, y: 0, duration: 0.6 },
                "-=0.3"
            );
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.estado !== this.state.estado) {
            const activo = this.state.estado ? this.btnPrevRef.current : this.btnProtRef.current;
            const inactivo = this.state.estado ? this.btnProtRef.current : this.btnPrevRef.current;
            gsap.to(inactivo, { scale: 1, duration: 0.25, ease: "power2.out" });

            gsap.fromTo(
                activo,
                { scale: 1 },
                { scale: 1.03, duration: 0.35, ease: "power2.out" }
            );

            gsap.fromTo(
                this.tituloRef.current,
                { opacity: 0, y: 10 },
                { opacity: 1, y: 0, duration: 0.4, ease: "power2.out" }
            );
        }

        if (
            prevState.planes !== this.state.planes || prevState.seguros !== this.state.seguros
        ) {
            if (this.sliderContRef.current) {
                gsap.fromTo(
                    this.sliderContRef.current,
                    { opacity: 0, y: 30 },
                    { opacity: 1, y: 0, duration: 0.5, ease: "power3.out" }
                );
            }
        }

        if (!prevState.cambiovista && this.state.cambiovista) {
            if (this.detalleRef.current) {
                gsap.fromTo(
                    this.detalleRef.current,
                    { opacity: 0, y: 40 },
                    { opacity: 1, y: 0, duration: 0.5, ease: "power3.out" }
                );
            }
        }

        if (prevState.cambiovista && !this.state.cambiovista) {
            if (this.sliderContRef.current) {
                gsap.fromTo(
                    this.sliderContRef.current,
                    { opacity: 0, y: 30 },
                    { opacity: 1, y: 0, duration: 0.5, ease: "power3.out" }
                );
            }
        }
    }

    DatosSeguros = async () => {
        const { estado } = this.state;
        const tipo = estado ? 1 : 2;
        const data = {
            tran: 4,
            idseguro: 0,
            idtiposeguro: 0,
            idtipopers: 0,
            nombre: "NA",
            descripcion: "NA",
            rutaimg: "NA",
            estado: 1,
            idusucrea: 0,
            feccrea: null,
        };

        try {
            const response = await DetalleSeguros_(data);
            const cantregistros = response?.length ?? 0;

            if (cantregistros > 0 && !response[0]?.message) {
                const datos = response
                .filter(item => item.idtiposeguro === tipo)
                .map(item => ({
                    id: item.idseguro,
                    titulo: item.nombre,
                    imagen: `${URLImgFront}/assets/${item.rutaimg}`,
                    descripcion: item.descripcion,
                }));

                if (tipo === 1) {
                    this.setState({ planes: datos, indexactual: 0 });
                } else {
                    this.setState({ seguros: datos, indexactual: 0 });
                }
            } else {
                this.setState({ planes: [], seguros: [] });
            }
        } catch (error) {
            Swal.fire({
                icon: 'error',
                text: 'Ocurrió un error al consumir el servicio'
            });
        }
    };

    animar = (index) => {
        this.animacion = true;
        gsap.to(this.sliderRef.current, {
            x: -(index * this.anchoCard),
            duration: 0.6,
            ease: "power2.out",
            onComplete: () => {
                this.animacion = false;
                this.handleInfinito(index);
            }
        });
    };

    handleInfinito = (index) => {
        const { planes, seguros } = this.state;
        const slide = this.state.estado ? planes : seguros;
        if (index >= slide.length) {
            gsap.set(this.sliderRef.current, { x: 0 });
            this.setState({ indexactual: 0 });
        }
    };

    cardSiguiente = () => {
        if (this.animacion) return;
        const nuevoindex = this.state.indexactual + 1;
        this.setState({ indexactual: nuevoindex }, () => this.animar(nuevoindex));
    };

    cardAnterior = () => {
        if (this.animacion) return;
        const { indexactual, planes, seguros } = this.state;
        const slide = this.state.estado ? planes : seguros;
        if (indexactual === 0) {
            const salto = slide.length;
            gsap.set(this.sliderRef.current, { x: -(salto * this.anchoCard) });
            this.setState({ indexactual: salto - 1 }, () => this.animar(salto - 1));
        } else {
            const nuevoindex = indexactual - 1;
            this.setState({ indexactual: nuevoindex }, () => this.animar(nuevoindex));
        }
    };

    cambiarEstado = (id) => {
        this.setState(
            {
                estado: id !== 0,
                cambiovista: false,
                indexactual: 0,
                mostrar: false
            }, () => {
                gsap.set(this.sliderRef.current, { x: 0 });
                this.DatosSeguros();
            }
        );
    };

    cambiarVista = (id, idvista, rutaimg, titulo, descrip) => {
        this.setState((prev) => ({
            cambiovista: !prev.cambiovista,
            idplan: id,
            vista: idvista,
            ruta: rutaimg,
            titulosegu: titulo,
            descripsegu: descrip
        }));
    };

    render() {
        const { estado, planes, seguros, mostrar } = this.state;    const slider = estado ? [...planes, ...planes] : [...seguros, ...seguros];

        return (
            <React.Fragment>
                <div className="bg-white" style={{ width: '100%' }}>
                    <div className="text-center seguro-seccion">
                        <div className="row py-2 align-items-center justify-content-around" style={{ margin: '0px' }}>
                            <div className="col-md-auto my-2 d-flex seguro-contenedor-tab">
                                <div ref={this.btnPrevRef}>
                                    <div className={`seguro-tab ${estado ? '' : 'activo'}`} onClick={() => this.cambiarEstado(1)} tabIndex={0} onKeyDown={(e) => e.key === 'Enter' && this.cambiarEstado(1)} style={{backgroundColor: estado ? '#FA7500' : 'transparent', display: 'inline-block' }} >
                                        <img src={`${URLImgFront}/assets/Seguros/Iconos/Prevision.svg`} className={`prevision-tab-item ${estado ? '' : 'activo'}`} alt="PREVISIÓN EXEQUIAL" style={{ pointerEvents: 'none' }} />
                                    </div>
                                    <p className="seguro-texto-contenido font-weight-bold mt-2" onClick={() => this.cambiarEstado(1)} style={estado ? { borderBottom: '3px solid #FA7500', cursor: 'pointer', textAlign: 'center' } : { borderBottom: 'none', cursor: 'pointer', textAlign: 'center' }}  >
                                        PREVISIÓN EXEQUIAL
                                    </p>
                                </div>
                                <div ref={this.btnProtRef}>
                                    <div className={`seguro-tab ${!estado ? 'activo' : ''}`} onClick={() => this.cambiarEstado(0)} tabIndex={0} onKeyDown={(e) => e.key === 'Enter' && this.cambiarEstado(0)} style={{ backgroundColor: !estado ? '#FA7500' : 'transparent', display: 'inline-block' }} >
                                        <img src={`${URLImgFront}/assets/Seguros/Iconos/Proteccion.svg`} className={`seguro-tab-item ${!estado ? 'activo' : ''}`} alt="PROTECCIÓN" style={{ pointerEvents: 'none' }} />
                                    </div>
                                    <p className="seguro-texto-contenido font-weight-bold mt-2" onClick={() => this.cambiarEstado(0)} style={!estado ? { borderBottom: '3px solid #FA7500', cursor: 'pointer', textAlign: 'center' } : { borderBottom: 'none', cursor: 'pointer', textAlign: 'center' }}  >
                                        PROTECCIÓN
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="row align-items-center justify-content-center" ref={this.tituloRef} style={{ margin: '0px' }}>
                            <p className="seguro-texto-descrip mb-5">
                                {estado
                                    ? <>UTRAHUILCA y EMCOOFUN Red Los Olivos se unen para ofrecerte una protección exequial integral que se <br />ajusta a tus necesidades, brindándote tranquilidad y acompañamiento en los momentos más difíciles.</>
                                    : <>UTRAHUILCA y EQUIDAD se unen para brindarte tranquilidad. Accede a un amplio portafolio de soluciones <br />diseñado para adaptarse a tus necesidades y garantizar la protección que necesitas ante cualquier eventualidad.</>}
                            </p>
                        </div>
                        <div className="col">
                            {!this.state.cambiovista ? (
                                <div ref={this.sliderContRef}>
                                    <div className="row align-items-center justify-content-center">
                                        <div className="col-auto seguro-btn-izquierda">
                                            <button className="seguro-btn-slider" onClick={this.cardAnterior}><img src={`${URLImgFront}/assets/Seguros/Iconos/SlideIzquierda.svg`} alt="prev" /></button>
                                        </div>
                                        <div style={{ width: this.anchoCard * this.cardsVisibles, overflow: "hidden" }}>
                                            <div ref={this.sliderRef} style={{ display: "flex" }}>
                                                {slider.map((item, index) => (
                                                    <div key={`${item.id}-${index}`} style={{ width: this.anchoCard }} className="seguro-card py-4" >
                                                        <div className="p-4 card seguro-slide" style={{ alignItems: "center" }}>
                                                            <img className="seguro-cardimg" src={item.imagen} alt={`card-${index}`} />
                                                            <h5 className="mt-2" style={{ color: "#545454", fontSize: "25px", cursor: "default" }}>{item.titulo}</h5>
                                                            <img src={`${URLImgFront}/assets/Seguros/Info.png`} style={{ cursor: "pointer", width: '150px' }} className="d-flex" onClick={() => this.cambiarVista(item.id, estado ? 1 : 0, item.imagen, item.titulo, item.descripcion)} alt="InfoSeguros" ></img>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                        <div className="col-auto seguro-btn-derecha">
                                            <button className="seguro-btn-slider" onClick={this.cardSiguiente}>
                                                <img src={`${URLImgFront}/assets/Seguros/Iconos/SlideDerecha.svg`} alt="next" />
                                            </button>
                                        </div>
                                    </div>
                                    <button id="btnPreguntasFrecuentes" style={{ backgroundImage: `url(${URLImgFront}/assets/Seguros/BtnPreguntasFrecuentes.webp)` }} className="rounded-pill seguro-btn-faq" onClick={() => this.setState((prev) => ({ mostrar: !prev.mostrar }))} />
                                    <div className="row pb-5 align-items-center justify-content-center">
                                        {mostrar && <PreguntasFrecuentesSeguros estado={estado} />}
                                    </div>
                                </div>
                            ) : (
                                <div ref={this.detalleRef}>
                                    {this.state.vista === 1 ? <Detalle_PlanExequial id={this.state.idplan} ruta={this.state.ruta} titulo={this.state.titulosegu} description={this.state.descripsegu} estado={estado} onAccion={this.cambiarEstado} /> : <Detalle_Seguro id={this.state.idplan} ruta={this.state.ruta} titulo={this.state.titulosegu} description={this.state.descripsegu} estado={estado} onAccion={this.cambiarEstado} />}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}
export default Seccion2;